<template>
  <div>
    <p>
      For each output (performance metric) the minimum, average and maximum
      values are computed on the ensemble of data. The median is also returned
      in order to evaluate the impact of extreme values on the average.
    </p>
    <p>
      <b>Custom percentile</b>: the user can specify a custom value
      (<katex-element expression="p \in [0, 100]" />) to compute the
      <katex-element expression="p" />-th percentile.
      <br />
      <br />
      <v-img
        contain
        :src="
          require('../../../assets/images/tooltip-constellation-statistics.png')
        "
        aspect-ratio="1.6"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipCustomPercentile'
}
</script>
